import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Extended tailwind-merge that understands devforge display text sizes.
 * Single source of truth for class merging across both shadcn/ui
 * and devforge component systems.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ['display-xs', 'display-sm', 'display-md', 'display-lg', 'display-xl', 'display-2xl'],
        },
    },
});

/**
 * Primary class merge utility. Combines class names with clsx and
 * deduplicates Tailwind classes via tailwind-merge.
 *
 * Replaces both `cn()` (shadcn convention) and `cx()` (devforge
 * convention) as a single export.
 */
export const cx = twMerge;

/** @deprecated Use `cx` instead. Kept for shadcn/ui component compatibility. */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}

/**
 * Helper for sorting classes inside style objects.
 * Enables Tailwind IntelliSense support in named class maps.
 */
export function sortCx<T extends Record<string, string | number | Record<string, string | number | Record<string, string | number>>>>(classes: T): T {
    return classes;
}
